export default {
  init() {
    // JavaScript to be fired on all pages
    console.log("test");
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var sticky = $(".stickyClick");
    var stickyBox = $(".stickyQuoteBox");

    setTimeout(function () {
      stickyBox.addClass("stickyQuoteActive");
    }, 3000);

    sticky.on("click", function () {
      if (stickyBox.hasClass("stickyQuoteActive")) {
        stickyBox.removeClass("stickyQuoteActive");
      } else {
        stickyBox.addClass("stickyQuoteActive");
      }
    });

    $(".vehicleTypeSelectize.select").selectize(); 
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js